var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6450_39887)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.109 2.013C8.60822 0.720203 10.5204 0.00620777 12.5 0C16.535 0 19.8845 3 20.249 6.8685C22.637 7.206 24.5 9.2055 24.5 11.6595C24.5 14.3535 22.253 16.5 19.5305 16.5H15.5C15.3011 16.5 15.1103 16.421 14.9697 16.2803C14.829 16.1397 14.75 15.9489 14.75 15.75C14.75 15.5511 14.829 15.3603 14.9697 15.2197C15.1103 15.079 15.3011 15 15.5 15H19.532C21.4685 15 23 13.482 23 11.6595C23 9.8355 21.47 8.3175 19.5305 8.3175H18.7805V7.5675C18.782 4.2375 15.992 1.5 12.5 1.5C10.8798 1.50647 9.31526 2.09165 8.0885 3.15C6.953 4.128 6.359 5.307 6.359 6.2325V6.9045L5.6915 6.978C3.596 7.2075 2 8.928 2 10.977C2 13.1775 3.845 15 6.1715 15H9.5C9.69891 15 9.88968 15.079 10.0303 15.2197C10.171 15.3603 10.25 15.5511 10.25 15.75C10.25 15.9489 10.171 16.1397 10.0303 16.2803C9.88968 16.421 9.69891 16.5 9.5 16.5H6.1715C3.062 16.5 0.5 14.049 0.5 10.977C0.5 8.3325 2.399 6.1425 4.913 5.5875C5.1275 4.293 5.96 3.003 7.109 2.013Z",
    fill: "#1F242E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9699 6.21936C12.0396 6.14952 12.1224 6.0941 12.2135 6.0563C12.3046 6.01849 12.4023 5.99902 12.5009 5.99902C12.5996 5.99902 12.6973 6.01849 12.7884 6.0563C12.8795 6.0941 12.9623 6.14952 13.0319 6.21936L17.5319 10.7194C17.6728 10.8602 17.7519 11.0512 17.7519 11.2504C17.7519 11.4495 17.6728 11.6405 17.5319 11.7814C17.3911 11.9222 17.2001 12.0013 17.0009 12.0013C16.8018 12.0013 16.6108 11.9222 16.4699 11.7814L13.2509 8.56086V21.7504C13.2509 21.9493 13.1719 22.14 13.0313 22.2807C12.8906 22.4213 12.6999 22.5004 12.5009 22.5004C12.302 22.5004 12.1113 22.4213 11.9706 22.2807C11.83 22.14 11.7509 21.9493 11.7509 21.7504V8.56086L8.53195 11.7814C8.39112 11.9222 8.20011 12.0013 8.00095 12.0013C7.80178 12.0013 7.61078 11.9222 7.46995 11.7814C7.32912 11.6405 7.25 11.4495 7.25 11.2504C7.25 11.0512 7.32912 10.8602 7.46995 10.7194L11.9699 6.21936Z",
    fill: "#1F242E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6450_39887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.016a8a27e67598be318182e9105aef3d.svg";
export { ForwardRef as ReactComponent };